import axios from "axios";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BLOG_BASE_URL } from "../services/blogService";
import Loading from "../utils/Loading";
import "./BlogStyle.css";
import BlogHero from "./BlogHero";

const BlogList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const results = blogs.filter(
      (blog) =>
        blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.author.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results);
  }, [searchTerm, blogs]);

  const fetchBlogData = async () => {
    try {
      const { data } = await axios.get(`${BLOG_BASE_URL}/api/blogs/list`);
      setBlogs(Array.isArray(data) ? data : []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogData();
  }, []);

  if (loading) return <Loading />;

  if (error) {
    return (
      <div className="error-container">
        <div className="error-message">
          <i className="fa fa-exclamation-triangle"></i>
          <span>Error loading blogs: {error.message}</span>
        </div>
      </div>
    );
  }

  return (
    <section className="blog-list-container">
      {blogs.length > 0 && (
        <BlogHero searchTerm={searchTerm} handleChange={handleChange} />
      )}

      <div className="blog-content-container">
        {blogs.length === 0 && (
          <div className="empty-blog-message">
            <i className="fa fa-book-open"></i>
            <h3>No blogs found!</h3>
            <p>Be the first to share your knowledge</p>
            <Link to="/api/dashboard/create" className="create-blog-btn">
              Create Your First Blog
            </Link>
          </div>
        )}

        {searchResults.length === 0 && searchTerm !== "" ? (
          <div className="search-not-found">
            <i className="fa fa-search"></i>
            <h4>
              No results found for "<span>{searchTerm}</span>"
            </h4>
            <Link to="/api/blogs" className="clear-search-btn">
              Clear Search
            </Link>
          </div>
        ) : (
          <div className="blog-posts-grid">
            {searchResults.map((blog) => (
              <article className="blog-card" key={blog._id}>
                <div className="blog-image-container">
                  <Link
                    to={`/api/blogs/blog-details/${
                      blog._id
                    }/${blog.title.replace(/\s+/g, "-")}`}
                  >
                    <img
                      src={blog.blogImage}
                      alt={blog.title || "blog post image"}
                      className="blog-image"
                    />
                    <div className="image-overlay"></div>
                  </Link>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="author">
                      <i className="fa fa-user"></i>{" "}
                      {blog.author || "Anonymous"}
                    </span>
                    <span className="date">
                      <i className="fa fa-calendar-alt"></i>{" "}
                      {format(new Date(blog.createdAt), "MMMM d, yyyy")}
                    </span>
                  </div>
                  <Link
                    to={`/api/blogs/blog-details/${
                      blog._id
                    }/${blog.title.replace(/\s+/g, "-")}`}
                  >
                    <h2 className="blog-title">{blog.title}</h2>
                  </Link>
                  <p className="blog-excerpt">{blog.summary}</p>
                  <Link
                    to={`/api/blogs/blog-details/${
                      blog._id
                    }/${blog.title.replace(/\s+/g, "-")}`}
                    className="read-more-btn"
                  >
                    Read More <i className="fa fa-arrow-right"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogList;
